import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

document.addEventListener('DOMContentLoaded', function () {
    // Initialize Masonry (legacy gallery layout)
    const grid = document.querySelector('[data-masonry]');
    
    if (grid) {
        imagesLoaded(grid, function() {
            new Masonry(grid, {
                itemSelector: '.gallery-col',
                columnWidth: '.gallery-col',
                percentPosition: true,
                gutter: 0
            });
        });
    }

    // Initialize PhotoSwipe Lightbox for both masonry and swiper variants
    document.querySelectorAll('.row[data-masonry], .swiper-gallery').forEach((galleryEl) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: galleryEl,
            children: 'a',
            pswpModule: () => import('photoswipe'),
            bgOpacity: 0.9,
            padding: { top: 50, bottom: 50, left: 50, right: 50 }
        });

        lightbox.init();
    });
});
